import React from "react";

const VideoPlayer = ({ videoUrl }) => {
  if (!videoUrl) return null;

  // Detect video type and generate embed URL
  const getEmbedUrl = (url) => {
    // --- CHECK IF ALREADY YOUTUBE EMBED URL ---
    if (url.match(/youtube\.com\/embed\//)) {
      return {
        type: "iframe",
        src: url,
      };
    }

    // --- CHECK IF ALREADY VIMEO EMBED URL ---
    if (url.match(/player\.vimeo\.com\/video\//)) {
      return {
        type: "iframe",
        src: url,
      };
    }

    // --- YOUTUBE ---
    const youtubeMatch =
      url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/);
    if (youtubeMatch) {
      return {
        type: "iframe",
        src: `https://www.youtube.com/embed/${youtubeMatch[1]}`,
      };
    }

    // --- VIMEO ---
    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
      return {
        type: "iframe",
        src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
      };
    }

    // --- DIRECT VIDEO FILE (mp4, webm, mov) ---
    if (url.match(/\.(mp4|webm|mov|m3u8|ogg)$/i)) {
      return { type: "video", src: url };
    }

    // --- UNKNOWN / NORMAL URL (just render a link) ---
    return { type: "link", src: url };
  };

  const video = getEmbedUrl(videoUrl);

  // Render based on type
  if (video.type === "iframe") {
    return (
      <iframe
        src={video.src}
        width="100%"
        height="200"
        style={{ border: "none", borderRadius: "12px" }}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="video-player"
      />
    );
  }

  if (video.type === "video") {
    return (
      <video
        src={video.src}
        controls
        style={{
          width: "100%",
          borderRadius: "12px",
        }}
      />
    );
  }

  // Fallback: just show clickable URL
  return (
    <a href={video.src} target="_blank" rel="noopener noreferrer">
      Open Video
    </a>
  );
};

export default VideoPlayer;
